import { Controller } from "@hotwired/stimulus"

// Flushes the server-queued GTM funnel events into window.dataLayer.
//
// The payload is rendered by app/views/shared/_analytics_events.html.erb, which
// queues it once per conversion (TracksAnalyticsEvents#track_analytics_event).
//
// This deliberately lives in the BUNDLED javascript rather than in an inline
// <script> next to the data element. The iubenda CMP loads before GTM to block
// tags until consent, and its autoblocker neutralises <script> tags it finds
// after itself — it rewrites them to type="text/plain" and cancels their
// execution, then only restores the ones it can attribute to a consented
// vendor. An inline first-party push matches no vendor, so it was suppressed
// and never restored: the conversion reached the Conversions API server-side
// but never the Pixel. application.js is a first-party <script src> the
// autoblocker leaves alone (it has to — Turbo and the whole UI live in it).
//
// connect() covers both entry paths: the full page load the sign-up redirect
// lands on, and Turbo navigations.
export default class extends Controller {
  static values = { payload: Array }

  connect() {
    window.dataLayer = window.dataLayer || []
    this.payloadValue.forEach((event) => window.dataLayer.push(event))
    // Each event must fire exactly once — an inflated conversion count
    // silently misreports ad spend.
    this.element.remove()
  }
}
